import { render } from "./PrescriptionDetails.vue?vue&type=template&id=e6cbe9cc&ts=true"
import script from "./PrescriptionDetails.vue?vue&type=script&lang=ts"
export * from "./PrescriptionDetails.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\kmccullough\\Source\\Repos\\CPHub\\DoctorQueue.FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__